// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/karriere/initativbewerbung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const karriereInitativbewerbungDE: PageEntry = {
  id: "post.karriere-initativbewerbung",
  locale: "de",
  slug: "karriere/initativbewerbung",
  seo: {
    navLabel: "Initiativbewerbung",
    title: "Initativbewerbung | Dietz GmbH",
    description: "Initativbewerbung",
  },
  type: "post",
  h1: "Initativbewerbung",
  blocks: [
    { kind: "image", src: "/images/live/dietz_aussen.jpg", alt: "Firmengebäude Dietz", width: 1280, height: 400 },
    { kind: "heading", level: 2, text: "DIETZ als Arbeitgeber" },
    { kind: "heading", level: 2, text: "Wir haben Dich überzeugt?" },
    { kind: "paragraph", text: "Zeig uns Deine Einzigartigkeit und bewirb Dich jetzt initiativ. Bei uns hast Du die Möglichkeit, Deine individuellen Fähigkeiten und Interessen in die Tat umzusetzen und innovative Projekte voranzutreiben. Nutz diese Chance, um wertvolle Erfahrungen zu sammeln und Dich persönlich sowie beruflich weiterzuentwickeln." },
    { kind: "image", src: "/images/live/Andrea-Dietz.jpg", alt: "Initativbewerbung", width: 773, height: 640 },
    { kind: "paragraph", text: "Du bist überzeugt von unserem Unternehmen? Bewirb Dich einfach initiativ bei uns." },
    { kind: "paragraph", text: "Wir melden uns dann in Kürze bei Dir." },
    { kind: "paragraph", text: "Tun Sie Gutes für die Umwelt und füllen Sie direkt hier Ihre grüne, papierlose Bewerbung aus." },
    { kind: "paragraph", text: "Zum Datenschutz" },
    { kind: "paragraph", text: "Ihre Ansprechpartnerin" },
    { kind: "paragraph", text: "Andrea Dietz Leitung Personalwesen" },
    { kind: "list", items: ["09568 9442 119", "karriere@dietz.eu"] }
  ],
};
